import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';

const ShipmentCostChargeListTemplate = ({
	t,
	viewStore,
	viewStore: { tableData, queryUtility, loading, showActions, data },
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<BaasicTable
				actions={viewStore}
				data={data != null ? data.slice() : null}
				{...{ tableData, queryUtility, showActions, viewStore }}
			/>
			<ReactTooltip />
		</React.Fragment>
	);
};

export default defaultTemplate(ShipmentCostChargeListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-cost/pages/ShipmentCostChargeListTemplate.jsx